const dictPermissionsModuleDevoluciones: { [key: string]: any } = Object.freeze(
  {
    module_devoluciones: 903,
  }
);

export const listPermissionsModuleDevoluciones = Object.keys(
  dictPermissionsModuleDevoluciones
).map((key: string) => dictPermissionsModuleDevoluciones[key]);
